import { render, staticRenderFns } from "./PerintaUusi.vue?vue&type=template&id=280ce7bb&scoped=true&"
import script from "./PerintaUusi.vue?vue&type=script&lang=js&"
export * from "./PerintaUusi.vue?vue&type=script&lang=js&"
import style0 from "./PerintaUusi.vue?vue&type=style&index=0&id=280ce7bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ce7bb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VToolbar,VToolbarTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280ce7bb')) {
      api.createRecord('280ce7bb', component.options)
    } else {
      api.reload('280ce7bb', component.options)
    }
    module.hot.accept("./PerintaUusi.vue?vue&type=template&id=280ce7bb&scoped=true&", function () {
      api.rerender('280ce7bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PerintaUusi.vue"
export default component.exports